module.exports = __webpack_public_path__ + "static/media/sv.a64aa0bf.svg";